import React from 'react';
import { CTAButton } from './CTAButton';
export const FinalPrice: React.FC = () => {
  return <section className="py-12 md:py-20 px-4 max-w-4xl mx-auto" data-id="element-83">
      <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16" data-id="element-84">
        <div className="w-full md:w-1/2 relative" data-id="element-85">
          <div className="absolute inset-0 bg-terracotta/5 rounded-3xl blur-2xl transform scale-105" data-id="element-86"></div>
          <img src="https://cdn.magicpatterns.com/uploads/hAjf9WjgLsshdMDJqGpRnd/ChatGPT_Image_29_abr_2026,_15_44_05.png" alt="Embarazo Sin Acidez" className="w-full h-auto relative z-10 drop-shadow-xl rounded-xl" data-id="element-87" />
        </div>

        <div className="w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-88">
          <h2 className="font-serif text-3xl md:text-4xl text-earth font-bold mb-6 leading-tight" data-id="element-89">
            Recuperá tu descanso por el precio de una cena afuera.
          </h2>

          <div className="bg-cream-card w-full rounded-2xl p-6 md:p-8 mb-8 border border-terracotta/10" data-id="element-90">
            <div className="flex flex-col items-center md:items-start mb-2" data-id="element-91">
              <span className="text-earth-light line-through text-lg mb-1" data-id="element-92">
                Valor regular: $28.400
              </span>
              <div className="flex items-baseline gap-2" data-id="element-93">
                <span className="text-terracotta font-bold text-5xl md:text-6xl tracking-tight" data-id="element-94">
                  $14.200
                </span>
                <span className="text-terracotta font-bold text-xl" data-id="element-95">ARS</span>
              </div>
            </div>
            <p className="font-sans text-earth font-medium mt-4 bg-white inline-block px-3 py-1 rounded-md text-sm border border-terracotta/20" data-id="element-96">
              Un solo pago, sin suscripciones.
            </p>
          </div>

          <CTAButton className="w-full md:w-auto px-10" data-id="element-97">
            LO QUIERO: ACCESO INMEDIATO
          </CTAButton>
        </div>
      </div>
    </section>;
};